var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    { attrs: { content: _vm.customerTip, placement: "bottom" } },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                (_vm.contractStatus === 2 &&
                  typeof _vm.customerLevel.level === "number") ||
                parseInt(_vm.customerLevel.level) > -1,
              expression:
                "(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
            }
          ],
          staticClass: "orange"
        },
        [_vm._v("LV" + _vm._s(_vm.customerLevel.level))]
      ),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                (_vm.contractStatus === 2 &&
                  typeof _vm.customerLevel.level === "number") ||
                parseInt(_vm.customerLevel.level) > -1,
              expression:
                "(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
            }
          ],
          staticStyle: { color: "#D3A73B" }
        },
        [_vm._v(" " + _vm._s(_vm.customerLevel.customerName))]
      ),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.contractStatusLabel,
              expression: "contractStatusLabel"
            }
          ],
          staticClass: "red"
        },
        [_vm._v(" (" + _vm._s(_vm.contractStatusLabel) + ")")]
      ),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.advancePaymentLabel,
              expression: "advancePaymentLabel"
            }
          ],
          staticStyle: { color: "brown" }
        },
        [_vm._v(" (" + _vm._s(_vm.advancePaymentLabel) + ")")]
      ),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.stampPictureView.businessDocuments.length > 0,
              expression: "stampPictureView.businessDocuments.length > 0"
            }
          ],
          on: {
            click: function($event) {
              _vm.stampPictureView.visible = true
            }
          }
        },
        [
          _c("img", {
            staticStyle: { "text-align": "right" },
            attrs: {
              title: _vm.$t("Message.BookingSeal"),
              src: _vm.stampIcon,
              height: "14"
            }
          })
        ]
      ),
      _c("stamp-picture-view", {
        attrs: {
          visible: _vm.stampPictureView.visible,
          "business-documents": _vm.stampPictureView.businessDocuments
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.stampPictureView, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }